import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { ChatBlockDto } from '@features/shared/chat/data/dtos/chat-block.dto';
import { ChatBlock } from '@features/shared/chat/domain/models/chat-block.model';
import { Observable, map } from 'rxjs';
import { IStaffChatBlockRepository } from '../../domain/repositories/staff-chat-block.repository';

@Injectable()
export class StaffChatBlockRepositoryImpl implements IStaffChatBlockRepository {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  getConversationState(conversationId: string): Observable<ChatBlock> {
    return this.http
      .get<ChatBlockDto>(`${this.apiUrl}/api/chat/conversations/${conversationId}/block-state`)
      .pipe(map((dto) => ({ isBlocked: dto.IsBlocked, blockedAtUtc: dto.BlockedAtUtc })));
  }
}
